import React from 'react';

const ThumbDown = ({ filled, ...props }: React.SVGProps<SVGSVGElement> & { filled?: boolean }): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <mask
        id="mask0_1231_2602"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1231_2602)">
        {filled ? (
          <path
            d="M5 3H14.5V13L8.5 19L7.83333 18.5417C7.58333 18.3611 7.39931 18.1319 7.28125 17.8542C7.16319 17.5764 7.13889 17.2917 7.20833 17L8 13H2.5C2.08333 13 1.72917 12.8542 1.4375 12.5625C1.14583 12.2708 1 11.9167 1 11.5V10.3125C1 10.2014 1.01042 10.1007 1.03125 10.0104C1.05208 9.92014 1.08333 9.82639 1.125 9.72917L3.60417 3.91667C3.71528 3.63889 3.89931 3.41667 4.15625 3.25C4.41319 3.08333 4.69444 3 5 3ZM16 13V3H19V13H16Z"
            fill="currentColor"
          />
        ) : (
          <path
            d="M5 3H14.5V13L8.5 19L7.83333 18.5417C7.59722 18.375 7.41667 18.1632 7.29167 17.9062C7.16667 17.6493 7.13194 17.3819 7.1875 17.1042L7.20833 17L8 13H2.5C2.08333 13 1.72917 12.8542 1.4375 12.5625C1.14583 12.2708 1 11.9167 1 11.5V10.3125C1 10.2014 1.01042 10.1007 1.03125 10.0104C1.05208 9.92014 1.08333 9.82639 1.125 9.72917L3.60417 3.91667C3.71528 3.63889 3.89931 3.41667 4.15625 3.25C4.41319 3.08333 4.69444 3 5 3ZM13 4.5H5L2.5 10.3125V11.5H9.83333L8.8125 16.5625L13 12.375V4.5ZM14.5 13V11.5H17.5V4.5H14.5V3H19V13H14.5Z"
            fill="currentColor"
          />
        )}
      </g>
    </svg>
  );
};

export default ThumbDown;
